import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { CloudUpload, CameraAlt, DeleteForever, Cameraswitch } from "@mui/icons-material";
import Webcam from "react-webcam";
import { VisuallyHiddenInput } from "../utils";
import { DownloadFile } from "./shared/DownloadFile";

interface ReimbursementFileSectionProps {
  files: Array<{ name: string; path: string; type: string }>;
  fileError: string | null;
  uploading: boolean;
  uploadFile: any;
  photo: boolean;
  setPhoto: (val: boolean) => void;
  facingMode: boolean;
  setFacingMode: (val: boolean) => void;
  webcamRef: React.RefObject<Webcam>;
  takePhoto: () => void;
  uploadFiles: (e: React.ChangeEvent<HTMLInputElement>) => void;
  deleteFile: (fileName: string) => void;
}

const ReimbursementFileSection: React.FC<ReimbursementFileSectionProps> = ({
  files,
  fileError,
  uploading,
  uploadFile,
  photo,
  setPhoto,
  facingMode,
  setFacingMode,
  webcamRef,
  takePhoto,
  uploadFiles,
  deleteFile,
}) => {
  return (
    <>
      {files.length > 0 && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography variant="h3" sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}>
            Files
          </Typography>
          {files.map((file) => (
            <Typography
              key={file.name}
              sx={{ display: "flex", alignItems: "center", fontSize: { xs: "0.7rem", sm: "1rem" } }}
              variant="body1"
            >
              {file.name}
              <DownloadFile file={file} />
              <IconButton onClick={() => deleteFile(file.name)}>
                <DeleteForever />
              </IconButton>
            </Typography>
          ))}
        </Box>
      )}

      {/* Upload buttons */}
      {!photo && (
        <>
          <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}>
            <Button
              component="label"
              variant="contained"
              startIcon={<CloudUpload />}
              sx={{ fontSize: { xs: "0.675rem", sm: "0.875rem" } }}
            >
              Upload a file
              <VisuallyHiddenInput onChange={uploadFiles} type="file" data-testid="file-upload-input" />
            </Button>
            <Button
              sx={{ fontSize: { xs: "0.675rem", sm: "0.875rem" } }}
              startIcon={<CameraAlt />}
              variant="contained"
              color="primary"
              onClick={() => setPhoto(true)}
            >
              Take Photo
            </Button>
          </Box>
          {fileError && (
            <Typography color="error" sx={{ mt: 1, ml: 0.5 }}>
              {fileError}
            </Typography>
          )}
        </>
      )}

      {photo && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ maxWidth: "400px", maxHeight: "400px" }}>
            <Webcam
              videoConstraints={{ facingMode: facingMode ? "environment" : "user" }}
              ref={webcamRef}
              width="100%"
              height="100%"
              forceScreenshotSourceSize
              screenshotQuality={1}
              screenshotFormat="image/png"
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
            <Button onClick={takePhoto}>Take Photo</Button>
            <Button onClick={() => setPhoto(false)}>Cancel Photo</Button>
            <Button onClick={() => setFacingMode(!facingMode)}>
              <Cameraswitch />
            </Button>
          </Box>
        </Box>
      )}

      {uploading && (
        <Box>
          <Typography>Uploading {uploadFile.name}.</Typography>
        </Box>
      )}
    </>
  );
};

export default ReimbursementFileSection; 